// Google Analytics Utility Functions

// Google Analytics Measurement ID
export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'GA_MEASUREMENT_ID';

// Initialize Google Analytics
export const initGA = () => {
  if (typeof window !== 'undefined' && window.gtag && GA_MEASUREMENT_ID !== 'GA_MEASUREMENT_ID') {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_title: document.title,
      page_location: window.location.href,
    });
  }
};

// Track page views
export const trackPageView = (path, title) => {
  if (typeof window !== 'undefined' && window.gtag && GA_MEASUREMENT_ID !== 'GA_MEASUREMENT_ID') {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path,
      page_title: title,
      page_location: window.location.href,
    });
  }
};

// Track custom events
export const trackEvent = (action, category = 'General', label = '', value = null) => {
  if (typeof window !== 'undefined' && window.gtag && GA_MEASUREMENT_ID !== 'GA_MEASUREMENT_ID') {
    const eventData = {
      event_category: category,
      event_label: label,
    };
    
    if (value !== null) {
      eventData.value = value;
    }
    
    window.gtag('event', action, eventData);
  }
};

// Track outbound links
export const trackOutboundLink = (url, label = '') => {
  trackEvent('click', 'outbound_link', label || url);
};

// Track downloads
export const trackDownload = (fileName, fileType = '') => {
  trackEvent('download', 'file', `${fileName} (${fileType})`);
};

// Track search
export const trackSearch = (searchTerm, category = 'site_search') => {
  trackEvent('search', category, searchTerm);
};

// Track form submissions
export const trackFormSubmission = (formName, success = true) => {
  trackEvent(success ? 'form_submit_success' : 'form_submit_error', 'form', formName);
};

// Track video plays
export const trackVideoPlay = (videoTitle, videoUrl = '') => {
  trackEvent('video_play', 'engagement', videoTitle, videoUrl);
};

// Track button clicks
export const trackButtonClick = (buttonName, location = '') => {
  trackEvent('button_click', 'engagement', `${buttonName} ${location}`.trim());
};

// Track navigation
export const trackNavigation = (menuItem, section = 'main_nav') => {
  trackEvent('navigation', section, menuItem);
};

// Track external link clicks
export const trackExternalClick = (linkText, destination) => {
  trackEvent('external_link', 'outbound', `${linkText} -> ${destination}`);
};

// Debug mode for development
export const isDebugMode = () => {
  return process.env.NODE_ENV === 'development';
};

// Console log for debug mode
export const debugLog = (message, data = null) => {
  if (isDebugMode()) {
    console.log(`[GA Debug] ${message}`, data || '');
  }
}; 